/* eslint-disable react/prop-types */
import { Select } from "@mui/material";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import SoftButton from "components/SoftButton";
import React from "react";

export default function TableHeadItems({ filterInfo, onClearFilterClick, handleFilterChange, onFilterClick }) {

    return (
        <Grid container gap={2} mb={2}>
            <Grid item xs={12} md={6} lg={2}>
                <section>
                    <p style={{ fontSize: 12, marginTop: 10 }}>وضعیت</p>
                    <Select
                        name="status"
                        value={String(filterInfo?.status)}
                        onChange={handleFilterChange}
                        fullWidth
                    >
                        <MenuItem value="">
                            <em>هیچکدام</em>
                        </MenuItem>

                        <MenuItem value={'1'}>
                            در انتظار
                        </MenuItem>
                        <MenuItem value={'2'}>
                            انجام شد
                        </MenuItem>
                        <MenuItem value={'3'}>
                            لغو شده
                        </MenuItem>
                    </Select>
                </section>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
                <SoftButton
                    onClick={onFilterClick}
                    size="small"
                    style={{ marginTop: 30, width: 100 }}
                    variant="gradient"
                    color="info"
                >
                    فیلتر
                </SoftButton>
                <SoftButton
                    onClick={() => {
                        onClearFilterClick();
                    }}
                    size="small"
                    style={{ marginTop: 30, marginRight: 10, width: 44 }}
                    variant="outlined"
                    color="error"
                >
                    حذف
                </SoftButton>
            </Grid>
        </Grid>
    );
}
